import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-fill text-background-50 text-xl"></i>
                </div>
                <span className="font-heading text-xl font-bold text-white">97影院</span>
              </div>
              <p className="text-sm leading-relaxed text-foreground-400">
                免费高清影院在线观看平台。提供最新高清电影、热门电视剧全集，超清蓝光画质，不缓冲流畅播放，极致视觉享受。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link></li>
                <li><Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">影视库</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                {categories.filter(c => c.slug !== 'all').slice(0, 6).map(cat => (
                  <li key={cat.slug}>
                    <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">联系我们</h4>
              <ul className="space-y-2.5 text-sm text-foreground-400">
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                  <span>contact@97cinema.com</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line mt-0.5 text-primary-400"></i>
                  <span>400-888-9797</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line mt-0.5 text-primary-400"></i>
                  <span>北京市朝阳区影视产业园A座</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-foreground-800/30 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 97影院 版权所有 | 本站所有内容均来自互联网，仅供学习交流使用
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}